import React from "react";
import { FormItemProps } from "antd/lib/form";

import { PriceInput } from "./PriceInput";
import SCFormItem from "../SCFormItem";

/**
 * Pre-configured From Input component
 * @param props Component Props
 */
const PriceFormInputComponent = ({ children, ...rest }: FormItemProps) => {
  return (
    <SCFormItem colon={false} {...rest}>
      {children}
    </SCFormItem>
  );
};

export default Object.assign(PriceFormInputComponent, { PriceInput });
